import {Icon} from 'semantic-ui-react'
import {IErrorMessageProps} from '../..'
import './style.css'

export function ErrorMessage(props: IErrorMessageProps) {
  const {message, children} = props
  return (
    <div className='error-message'>
      <div className='header'>
        <Icon
          name='warning sign'
          color='red'
          size='large'
        />
        <span>{message}</span>
      </div>
      {children ?
        <div className='children'>{children}</div>
      : null}
    </div>
  )
}
